export const categories = [
  {
    id: 'perfumes-men',
    name: 'عطور رجالية',
    icon: 'ri-contrast-drop-2-line',
    count: 24,
    image: 'https://public.readdy.ai/ai/img_res/7aaaea9b5b52c4fc763f8822e70a781b.jpg',
    color: 'from-stone-800 to-stone-600',
  },
  {
    id: 'perfumes-women',
    name: 'عطور نسائية',
    icon: 'ri-seedling-line',
    count: 32,
    image: 'https://readdy.ai/api/search-image?query=cinematic%20feminine%20luxury%20perfume%20bottle%20dramatic%20dark%20studio%2C%20rose%20gold%20crystal%20bottle%20with%20spotlight%20illumination%2C%20deep%20black%20background%20with%20soft%20pink%20smoke%20and%20bokeh%2C%20ultra%20dramatic%20shadows%2C%20film%20noir%20beauty%20photography%2C%20premium%20Arabic%20womens%20fragrance%20editorial%2C%20moody%20elegant%20atmosphere&width=400&height=500&seq=cin_cat2&orientation=portrait',
    color: 'from-rose-200 to-pink-100',
  },
  {
    id: 'inner-wear',
    name: 'ملابس داخلية',
    icon: 'ri-t-shirt-line',
    count: 18,
    image: 'https://readdy.ai/api/search-image?query=cinematic%20premium%20fabric%20clothing%20dark%20dramatic%20studio%2C%20soft%20luxury%20cotton%20garment%20with%20single%20spotlight%2C%20deep%20black%20background%20with%20subtle%20texture%2C%20ultra%20dramatic%20shadows%2C%20film%20noir%20fashion%20photography%2C%20high-end%20innerwear%20editorial%2C%20moody%20dark%20atmosphere%20with%20warm%20light&width=400&height=500&seq=cin_cat3&orientation=portrait',
    color: 'from-amber-50 to-stone-100',
  },
  {
    id: 'outer-wear',
    name: 'ملابس خارجية',
    icon: 'ri-shirt-line',
    count: 45,
    image: 'https://readdy.ai/api/search-image?query=cinematic%20traditional%20Arabic%20thobe%20and%20abaya%20dark%20dramatic%20studio%2C%20gold%20embroidery%20details%20illuminated%20by%20single%20spotlight%2C%20deep%20black%20background%20with%20smoke%20and%20golden%20light%20rays%2C%20ultra%20dramatic%20shadows%2C%20film%20noir%20fashion%20photography%2C%20luxury%20Middle%20Eastern%20fashion%20editorial%2C%20moody%20cinematic%20atmosphere&width=400&height=500&seq=cin_cat4&orientation=portrait',
    color: 'from-zinc-700 to-zinc-500',
  },
];

export const products = [
  {
    id: '1',
    name: 'عود الملوك',
    category: 'perfumes-men',
    price: 450,
    oldPrice: 600,
    rating: 4.9,
    reviews: 128,
    badge: 'الأكثر مبيعاً',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20luxury%20oud%20perfume%20bottle%20dramatic%20dark%20studio%2C%20single%20spotlight%20on%20deep%20amber%20glass%20bottle%20with%20gold%20accents%2C%20pure%20black%20background%20with%20smoke%20wisps%20and%20warm%20amber%20glow%2C%20ultra%20dramatic%20shadows%2C%20film%20noir%20product%20photography%2C%20premium%20Arabian%20oud%20fragrance%20editorial%2C%20high%20contrast%20moody%20atmosphere&width=400&height=500&seq=cin_p1&orientation=portrait',
    description: 'عطر عود فاخر بروائح خشبية عميقة ومسك أصيل',
  },
  {
    id: '2',
    name: 'وردة الشرق',
    category: 'perfumes-women',
    price: 380,
    oldPrice: null,
    rating: 4.8,
    reviews: 95,
    badge: 'جديد',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20feminine%20luxury%20perfume%20bottle%20dark%20dramatic%20studio%2C%20elegant%20rose%20gold%20crystal%20bottle%20with%20dramatic%20spotlight%2C%20pure%20black%20background%20with%20soft%20pink%20smoke%20and%20rose%20petals%20floating%2C%20ultra%20dramatic%20shadows%2C%20film%20noir%20beauty%20photography%2C%20premium%20Arabic%20womens%20fragrance%20editorial%2C%20moody%20cinematic%20atmosphere&width=400&height=500&seq=cin_p2&orientation=portrait',
    description: 'عطر نسائي بزهور الورد والياسمين الفواح',
  },
  {
    id: '3',
    name: 'ليل المدينة',
    category: 'perfumes-men',
    price: 520,
    oldPrice: 650,
    rating: 4.7,
    reviews: 67,
    badge: null,
    image: 'https://readdy.ai/api/search-image?query=cinematic%20dark%20luxury%20mens%20perfume%20bottle%20midnight%20blue%20and%20gold%20design%2C%20dramatic%20spotlight%20on%20sophisticated%20bottle%2C%20pure%20black%20background%20with%20deep%20blue%20smoke%20and%20golden%20light%20streaks%2C%20ultra%20dramatic%20shadows%2C%20film%20noir%20product%20photography%2C%20premium%20masculine%20Arabian%20fragrance%20editorial%2C%20high%20contrast%20moody%20cinematic%20atmosphere&width=400&height=500&seq=cin_p3&orientation=portrait',
    description: 'عطر رجالي فاخر بروائح الليل والمسك الثمين',
  },
  {
    id: '4',
    name: 'طقم داخلي فاخر',
    category: 'inner-wear',
    price: 890,
    oldPrice: 1100,
    rating: 4.9,
    reviews: 43,
    badge: 'عرض خاص',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20premium%20luxury%20cotton%20underwear%20set%20dramatic%20dark%20studio%2C%20single%20spotlight%20on%20soft%20ivory%20cream%20fabric%20neatly%20folded%2C%20pure%20black%20background%20with%20warm%20golden%20light%20rays%20and%20subtle%20smoke%2C%20ultra%20dramatic%20shadows%2C%20film%20noir%20fashion%20photography%2C%20high-end%20innerwear%20editorial%2C%20moody%20cinematic%20atmosphere%20with%20warm%20tones&width=400&height=500&seq=cin_p4b&orientation=portrait',
    description: 'طقم ملابس داخلية فاخر من أجود أنواع القطن الناعم',
  },
  {
    id: '5',
    name: 'عباءة الأناقة',
    category: 'outer-wear',
    price: 750,
    oldPrice: null,
    rating: 4.8,
    reviews: 89,
    badge: 'جديد',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20elegant%20black%20abaya%20with%20gold%20embroidery%20dramatic%20dark%20studio%2C%20single%20spotlight%20on%20flowing%20black%20fabric%20with%20golden%20border%20details%2C%20pure%20black%20background%20with%20golden%20smoke%20and%20light%20rays%2C%20ultra%20dramatic%20shadows%2C%20film%20noir%20fashion%20photography%2C%20luxury%20Arabic%20womens%20fashion%20editorial%2C%20moody%20cinematic%20atmosphere&width=400&height=500&seq=cin_p5&orientation=portrait',
    description: 'عباءة سوداء فاخرة مع تطريز ذهبي رائع',
  },
  {
    id: '6',
    name: 'سحر الحريم',
    category: 'perfumes-women',
    price: 290,
    oldPrice: 350,
    rating: 4.6,
    reviews: 112,
    badge: null,
    image: 'https://readdy.ai/api/search-image?query=cinematic%20oriental%20luxury%20womens%20perfume%20bottle%20dramatic%20dark%20studio%2C%20purple%20and%20gold%20bottle%20with%20dramatic%20spotlight%2C%20pure%20black%20background%20with%20purple%20smoke%20and%20amber%20musk%20glow%2C%20ultra%20dramatic%20shadows%2C%20film%20noir%20beauty%20photography%2C%20premium%20Arabic%20oriental%20fragrance%20editorial%2C%20moody%20cinematic%20atmosphere&width=400&height=500&seq=cin_p6&orientation=portrait',
    description: 'عطر نسائي شرقي بروائح العنبر والمسك',
  },
  {
    id: '8',
    name: 'الذهب الأسود',
    category: 'perfumes-men',
    price: 680,
    oldPrice: null,
    rating: 5.0,
    reviews: 34,
    badge: 'حصري',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20ultra%20luxury%20black%20gold%20perfume%20bottle%20dramatic%20dark%20studio%2C%20single%20dramatic%20spotlight%20on%20black%20lacquer%20bottle%20with%20solid%20gold%20cap%2C%20pure%20black%20background%20with%20golden%20smoke%20and%20light%20rays%2C%20ultra%20dramatic%20shadows%2C%20film%20noir%20product%20photography%2C%20most%20exclusive%20Arabian%20fragrance%20editorial%2C%20high%20contrast%20moody%20cinematic%20atmosphere&width=400&height=500&seq=cin_p8&orientation=portrait',
    description: 'أفخر عطر رجالي بمزيج العود والذهب والمسك',
  },
];
